module.exports = __webpack_public_path__ + "img/1.b30128db.jpg";